import { observer } from 'mobx-react-lite'
import { uiStore } from 'shared/store/uiStore'
import { EnumAccessPageKeys } from 'entities/ExportRouters/lib/checkAccessPage'
import { AccessLayout, ConversationRoutes } from 'entities/ExportRouters'

export const AddOnsAccessLayout = observer(() => {
  return (
    <AccessLayout
      name={EnumAccessPageKeys.add_ons}
      onAccessDenied={() => {
        uiStore.changeRouteViaVue({
          path: ConversationRoutes.root,
        })
      }}
    />
  )
})
